// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-status {
	max-width: 800px;
	margin: 0 auto;
	padding: 20px;
}

.license-status h3 {
	margin-bottom: 20px;
	color: #333;
	font-size: 1.5rem;
}

.status-overview {
  margin-bottom: 1em;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.5em;
  border-radius: 4px;
  margin-bottom: 0.5em;
}

.status-icon {
  font-size: 1.2em;
  font-weight: bold;
}

.status-label {
  font-weight: bold;
  margin-right: 0.5em;
}

.status-value {
  text-transform: capitalize;
}

.status-valid {
  background-color: rgba(0, 255, 0, 0.1);
  border: 1px solid rgba(0, 255, 0, 0.3);
}

.status-trial {
  background-color: rgba(0, 123, 255, 0.1);
  border: 1px solid rgba(0, 123, 255, 0.3);
}

.status-stale {
  background-color: rgba(255, 165, 0, 0.1);
  border: 1px solid rgba(255, 165, 0, 0.3);
}

.status-expired {
  background-color: rgba(255, 0, 0, 0.1);
  border: 1px solid rgba(255, 0, 0, 0.3);
}

.status-error {
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.3);
}

.status-unlicensed {
  background-color: rgba(108, 117, 125, 0.1);
  border: 1px solid rgba(108, 117, 125, 0.3);
}

.status-na {
  background-color: rgba(173, 181, 189, 0.1);
  border: 1px solid rgba(173, 181, 189, 0.3);
}

.status-invalid {
  background-color: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.status-unknown {
  background-color: rgba(128, 128, 128, 0.1);
  border: 1px solid rgba(128, 128, 128, 0.3);
}

.license-details {
  margin-bottom: 1em;
}

.detail-section {
  margin-bottom: 1em;
}

.detail-section h4 {
  margin-bottom: 0.5em;
  color: #abc;
}

.detail-item {
  display: flex;
  gap: 0.5em;
  margin-bottom: 0.25em;
}

.detail-label {
  font-weight: bold;
  min-width: 120px;
}

.detail-value {
  text-transform: capitalize;
}

.detail-value.status-valid {
  color: #0f0;
}

.detail-value.status-trial {
  color: #007bff;
}

.detail-value.status-stale {
  color: #ffa500;
}

.detail-value.status-expired {
  color: #f00;
}

.detail-value.status-error {
  color: #dc3545;
}

.detail-value.status-unlicensed {
  color: #6c757d;
}

.detail-value.status-na {
  color: #adb5bd;
}

.detail-value.status-invalid {
  color: #ffc107;
}

.detail-value.status-unknown {
  color: #888;
}

.refresh-button {
	background: #007bff;
	color: white;
	border: none;
	padding: 12px 24px;
	border-radius: 6px;
	font-size: 1rem;
	cursor: pointer;
	transition: background-color 0.2s;
}

.refresh-button:hover {
	background: #0056b3;
}

.refresh-button:active {
	background: #004085;
}

.license-status-loading {
	text-align: center;
	padding: 40px;
	color: #6c757d;
	font-size: 1.1rem;
}

.license-status-error {
	text-align: center;
	padding: 20px;
	color: #dc3545;
	background: #f8d7da;
	border: 1px solid #f5c6cb;
	border-radius: 8px;
	margin: 20px 0;
}

.retry-button {
	background: #dc3545;
	color: white;
	border: none;
	padding: 8px 16px;
	border-radius: 4px;
	margin-left: 15px;
	cursor: pointer;
}

.retry-button:hover {
	background: #c82333;
}

@media (max-width: 768px) {
	.license-status {
		padding: 15px;
	}
	
	.license-details {
		grid-template-columns: 1fr;
		gap: 15px;
	}
	
	.status-item {
		flex-direction: column;
		align-items: flex-start;
	}
	
	.status-icon {
		margin-right: 0;
		margin-bottom: 10px;
	}
	
	.detail-item {
		flex-direction: column;
		align-items: flex-start;
	}
	
	.detail-label {
		margin-bottom: 5px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/containers/Licensing/LicenseStatus.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,cAAc;CACd,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,iBAAiB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,iCAAiC;AAClC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,0BAA0B;EAC1B,SAAS;CACV;;CAEA;EACC,sBAAsB;EACtB,uBAAuB;CACxB;;CAEA;EACC,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,sBAAsB;EACtB,uBAAuB;CACxB;;CAEA;EACC,kBAAkB;CACnB;AACD","sourcesContent":[".license-status {\n\tmax-width: 800px;\n\tmargin: 0 auto;\n\tpadding: 20px;\n}\n\n.license-status h3 {\n\tmargin-bottom: 20px;\n\tcolor: #333;\n\tfont-size: 1.5rem;\n}\n\n.status-overview {\n  margin-bottom: 1em;\n}\n\n.status-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5em;\n  padding: 0.5em;\n  border-radius: 4px;\n  margin-bottom: 0.5em;\n}\n\n.status-icon {\n  font-size: 1.2em;\n  font-weight: bold;\n}\n\n.status-label {\n  font-weight: bold;\n  margin-right: 0.5em;\n}\n\n.status-value {\n  text-transform: capitalize;\n}\n\n.status-valid {\n  background-color: rgba(0, 255, 0, 0.1);\n  border: 1px solid rgba(0, 255, 0, 0.3);\n}\n\n.status-trial {\n  background-color: rgba(0, 123, 255, 0.1);\n  border: 1px solid rgba(0, 123, 255, 0.3);\n}\n\n.status-stale {\n  background-color: rgba(255, 165, 0, 0.1);\n  border: 1px solid rgba(255, 165, 0, 0.3);\n}\n\n.status-expired {\n  background-color: rgba(255, 0, 0, 0.1);\n  border: 1px solid rgba(255, 0, 0, 0.3);\n}\n\n.status-error {\n  background-color: rgba(220, 53, 69, 0.1);\n  border: 1px solid rgba(220, 53, 69, 0.3);\n}\n\n.status-unlicensed {\n  background-color: rgba(108, 117, 125, 0.1);\n  border: 1px solid rgba(108, 117, 125, 0.3);\n}\n\n.status-na {\n  background-color: rgba(173, 181, 189, 0.1);\n  border: 1px solid rgba(173, 181, 189, 0.3);\n}\n\n.status-invalid {\n  background-color: rgba(255, 193, 7, 0.1);\n  border: 1px solid rgba(255, 193, 7, 0.3);\n}\n\n.status-unknown {\n  background-color: rgba(128, 128, 128, 0.1);\n  border: 1px solid rgba(128, 128, 128, 0.3);\n}\n\n.license-details {\n  margin-bottom: 1em;\n}\n\n.detail-section {\n  margin-bottom: 1em;\n}\n\n.detail-section h4 {\n  margin-bottom: 0.5em;\n  color: #abc;\n}\n\n.detail-item {\n  display: flex;\n  gap: 0.5em;\n  margin-bottom: 0.25em;\n}\n\n.detail-label {\n  font-weight: bold;\n  min-width: 120px;\n}\n\n.detail-value {\n  text-transform: capitalize;\n}\n\n.detail-value.status-valid {\n  color: #0f0;\n}\n\n.detail-value.status-trial {\n  color: #007bff;\n}\n\n.detail-value.status-stale {\n  color: #ffa500;\n}\n\n.detail-value.status-expired {\n  color: #f00;\n}\n\n.detail-value.status-error {\n  color: #dc3545;\n}\n\n.detail-value.status-unlicensed {\n  color: #6c757d;\n}\n\n.detail-value.status-na {\n  color: #adb5bd;\n}\n\n.detail-value.status-invalid {\n  color: #ffc107;\n}\n\n.detail-value.status-unknown {\n  color: #888;\n}\n\n.refresh-button {\n\tbackground: #007bff;\n\tcolor: white;\n\tborder: none;\n\tpadding: 12px 24px;\n\tborder-radius: 6px;\n\tfont-size: 1rem;\n\tcursor: pointer;\n\ttransition: background-color 0.2s;\n}\n\n.refresh-button:hover {\n\tbackground: #0056b3;\n}\n\n.refresh-button:active {\n\tbackground: #004085;\n}\n\n.license-status-loading {\n\ttext-align: center;\n\tpadding: 40px;\n\tcolor: #6c757d;\n\tfont-size: 1.1rem;\n}\n\n.license-status-error {\n\ttext-align: center;\n\tpadding: 20px;\n\tcolor: #dc3545;\n\tbackground: #f8d7da;\n\tborder: 1px solid #f5c6cb;\n\tborder-radius: 8px;\n\tmargin: 20px 0;\n}\n\n.retry-button {\n\tbackground: #dc3545;\n\tcolor: white;\n\tborder: none;\n\tpadding: 8px 16px;\n\tborder-radius: 4px;\n\tmargin-left: 15px;\n\tcursor: pointer;\n}\n\n.retry-button:hover {\n\tbackground: #c82333;\n}\n\n@media (max-width: 768px) {\n\t.license-status {\n\t\tpadding: 15px;\n\t}\n\t\n\t.license-details {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 15px;\n\t}\n\t\n\t.status-item {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t}\n\t\n\t.status-icon {\n\t\tmargin-right: 0;\n\t\tmargin-bottom: 10px;\n\t}\n\t\n\t.detail-item {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t}\n\t\n\t.detail-label {\n\t\tmargin-bottom: 5px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
